import API from "./api";

class SocketConnect extends API {
  socket = null;
  socket_url = '';
  socket_timer_error = null;
  socket_timer_visible = null
  socket_query = []
  socket_subscribers = []

  constructor(ctx, socket_url, urls) {
    super(ctx, urls);
    this.socket_url = socket_url
    this.subscribeSocketEvent(this.onSocket.bind(this))
  }

  onSocket() {
  }

  subscribeSocketEvent(callback) {
    this.socket_subscribers.push(callback)
    return () => {
      const index = this.socket_subscribers.indexOf(callback);
      if (index !== -1) {
        this.socket_subscribers.splice(index, 1);
      }
    }
  }


  socketReconnect(query) {
    this.set('status_connect', 'loading');
    return Promise.all([this.fetch(query), this.socketConnect(query)])
  }

  socketClear() {
    if (this.socket) {
      this.socket.close(1000)
      this.socket = null
    }
    if (this.socket_timer_error) {
      clearTimeout(this.socket_timer_error)
      this.socket_timer_error = null
    }
  }

  socketConnect(query) {
    this.socketClear()
    const ws_scheme = window.location.protocol === "https:" ? "wss" : "ws";
    let url = `${ws_scheme}://${window.location.host}${this.socket_url}`
    if (Object.keys(query).length > 0) {
      const params = new URLSearchParams(query);
      url += `?${params.toString()}`;
    }
    const socket = new WebSocket(url);

    socket.onmessage = (e) => {
      const event = JSON.parse(e.data)
      this.socket_subscribers.forEach(callback => callback(event))
    };

    socket.onclose = (e) => {
      if (e.code === 1000) {
        this.set('status_connect', '');
        return
      }
      if (!document.hidden) {
        this.set('status_connect', 'error');
        this.socketClear()
        this.socket_timer_error = setTimeout(() => {
          this.socketReconnect(query)
        }, Math.random() * 10000);
      }
    };

    socket.onopen = (e) => {
      this.set('status_connect', 'stable');
      const query = this.socket_query;
      this.socket_query = [];
      query.forEach(d => this.socketSend(d))
    };
    return this.socket = socket
  }

  socketSend(data) {
    if (this.socket) {
      if (this.socket.readyState !== 1) {
        this.socket_query.push(data)
      } else {
        this.socket.send(JSON.stringify(data))
      }
    }
  }

  subscribe(query = {}) {
    const filteredQuery = Object.fromEntries(
      Object.entries(query).filter(([_, value]) => value !== null && value !== undefined)
    );
    const visibilityHandler = this.listenerVisibilityChange(filteredQuery)
    if (!this.socket) {
      document.addEventListener("visibilitychange", visibilityHandler);
    }
    if (!document.hidden) {
      this.socketConnect(filteredQuery);
    }
    return () => {
      this.socketClear()
      document.removeEventListener("visibilitychange", visibilityHandler)
    }
  }

  listenerVisibilityChange = (query) => () => {
    if (document.hidden) {
      this.socket_timer_visible = setTimeout(() => {
        this.socketClear()
      }, 5000)
    } else {
      clearTimeout(this.socket_timer_visible)
      this.socketReconnect(query)
    }
  }
}

export default SocketConnect